var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0 -2)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4358 13.0849L20.3758 17.0949C20.5523 17.2857 20.6476 17.5377 20.6414 17.7975C20.6353 18.0573 20.5283 18.3046 20.3431 18.4869C20.1578 18.6691 19.9088 18.7721 19.6489 18.774C19.389 18.7759 19.1386 18.6765 18.9508 18.4969L15.0128 14.4909C13.4933 15.6356 11.5956 16.16 9.70403 15.9581C7.81242 15.7562 6.06821 14.8431 4.82457 13.4035C3.58094 11.9639 2.93081 10.1056 3.00584 8.2047C3.08087 6.30382 3.87544 4.50248 5.22867 3.16542C6.5819 1.82836 8.39266 1.05549 10.2943 1.00331C12.1959 0.951135 14.0464 1.62355 15.4709 2.88439C16.8954 4.14524 17.7875 5.9003 17.9667 7.7942C18.1458 9.6881 17.5986 11.5793 16.4358 13.0849ZM10.4998 13.9999C11.9584 13.9999 13.3574 13.4204 14.3888 12.389C15.4203 11.3575 15.9998 9.9586 15.9998 8.49991C15.9998 7.04122 15.4203 5.64227 14.3888 4.61082C13.3574 3.57937 11.9584 2.99991 10.4998 2.99991C9.04106 2.99991 7.64212 3.57937 6.61067 4.61082C5.57922 5.64227 4.99976 7.04122 4.99976 8.49991C4.99976 9.9586 5.57922 11.3575 6.61067 12.389C7.64212 13.4204 9.04106 13.9999 10.4998 13.9999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.fdf7f8ee269531999fa4f9366e54298a.svg";
export { ForwardRef as ReactComponent };